export const styles = {
    confirmDialog: {
        maxWidth: "460px",
        textAlign: "center",
    },
};
